/**
  *@页面的tabber页面
  *首页 分类 购物车 我的
  *2022-08-02 kadiam
  *2025-11-05 kadiam更新 修改底部样式为四个按钮 采购大厅 商品分类 购物车 订单中心
*/
<template>
  <div class="tabber">
    <!-- <div v-if="showcart" class="cart_bottom">
      <div class="cart_bottom_icon" @click="toCartPath">
        <van-image width="1.6rem" height="1.6rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/cart_icon.png"
        />
        <div v-if="$store.getters.totalShopping > 0" class="badge_box">{{ $store.getters.totalShopping }}</div>
      </div>
      <div class="cart_bottom_info flex-r-c-c">
        <div class="info_total">
          <span style="font-size: 0.32rem;color: #333;font-weight: 400;">合计：</span>
          <span style="font-size: 0.32rem;">￥</span><span>{{ $store.getters.totalShoppingMoney }}</span>
        </div>
        <div class="info_button" @click="toCartPath">去购物车</div>
      </div>
    </div> -->
    <div class="tabber2 flex-r-sa-c">
      <div class="tabber_btn flex-c-c-c" @click="changePath('',1)">
        <van-image v-if="myindex === 1" width="0.55rem" height="0.56rem"
                   :src="require('../../assets/UI2/tabber1-1.png')"
        />
        <van-image v-else width="0.55rem" height="0.56rem" :src="require('../../assets/UI2/tabber0-1.png')" />
        <span :class="myindex === 1?'tabber_choosed tabber_message':'tabber_message'">采购大厅</span>
      </div>
      <div class="tabber_btn flex-c-c-c" @click="changePath('',2)">
        <van-image v-if="myindex === 2" width="0.55rem" height="0.56rem"
                   :src="require('../../assets/UI2/tabber1-2.png')"
        />
        <van-image v-else width="0.55rem" height="0.56rem" :src="require('../../assets/UI2/tabber0-2.png')" />
        <span :class="myindex === 2?'tabber_choosed tabber_message':'tabber_message'">商品分类</span>
      </div>
      <van-badge :content="$store.getters.totalShopping*1 > 0 ? $store.getters.totalShopping : ''">
        <div class="tabber_btn flex-c-c-c" @click="changePath('',3)">
          <van-image v-if="myindex === 3" width="0.55rem" height="0.56rem"
                     :src="require('../../assets/UI2/tabber1-3.png')"
          />
          <van-image v-else width="0.55rem" height="0.56rem" :src="require('../../assets/UI2/tabber0-3.png')" />
          <span :class="myindex === 3?'tabber_choosed tabber_message':'tabber_message'">购物车</span>

        </div>
      </van-badge>
      <div class="tabber_btn flex-c-c-c" @click="changePath('',4)">
        <van-image v-if="myindex === 4" width="0.55rem" height="0.56rem"
                   :src="require('../../assets/UI2/tabber1-4.png')"
        />
        <van-image v-else width="0.55rem" height="0.56rem" :src="require('../../assets/UI2/tabber0-4.png')" />
        <span :class="myindex === 4?'tabber_choosed tabber_message':'tabber_message'">订单中心</span>
      </div>
      <!-- <div v-for="(item,item_index) in list" :key="item_index" class="tabber_btn flex-c-c-c"
           @click="changePath(item,item.sort)"
      >
        <van-image width="0.55rem" height="0.56rem" :src="myindex === item.sort?'https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/'+ item.sort +'-1.png'
          :'https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/'+ item.sort +'.png'"
        />
        <span :class="myindex === item.sort?'tabber_choosed tabber_message':'tabber_message'">{{ item.name }}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabber',
  props: {
    showcart: { type: Boolean, default: true },
    index: { type: Number, default: null }
    // list: { type: Array, default: null }
  },
  data() {
    return {
      myindex: this.index,
      alIndex: this.index
    }
  },
  methods: {
    toCartPath() { this.$router.push('/cart/cart') },
    changePath(item, path) {
      this.myindex = path
      // if (this.alIndex !== path) {
      //   if (path === 1) { this.$router.push('/home/index') }
      //   if (path === 2 || path === 3 || path === 4 || path === 5) { this.$router.push(item.imageValue) }
      // }
      if (path === 1) { this.$router.push('/home/index') }
      if (path === 2) { this.$router.push('/product/classify') }
      if (path === 3) { this.$router.push('/cart/cart') }
      if (path === 4) { this.$router.push('/user/my') }
    }
  }
}
</script>
<style lang="scss">
.tabber {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.tabber2 {
  width: 100%;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  background: #ffffff;
  border-top: 1px solid rgb(215, 215, 215);
  .tabber_message {
    font-size: 0.32rem;
    color: #b5b5b5;
  }
  .tabber_choosed {
    color: #0767ab;
    // color: #DE1323;
  }
}
</style>
